import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { interval, merge, Observable, Subscription } from 'rxjs';
import { catchError, exhaustMap, map, retry, share } from 'rxjs/operators';

import { LiveData } from '../models/api';

// const API = 'https://niji-mado-nntb58yxc.vercel.app/api/lives'; // STG
const API = 'https://niji-mado-r2.aliyo.me/home.json?v2';

const MSEC = 1;
const SEC = 1000 * MSEC;
const MIN = 60 * SEC;

const INTERVAL = 1 * MIN;
// const INTERVAL = 10 * SEC;
// const RETRY_INTERVAL = 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class LiveService implements OnDestroy {
  readonly lives$: Observable<
    { lives?: LiveData[]; connectionCount: number } | undefined
  >;

  private readonly subscription = new Subscription();

  constructor(http: HttpClient) {
    const getLivesFromApi = http
      .get<{ all: LiveData[]; connectionCount: number }>(API)
      .pipe(
        map((data) => ({
          lives: data.all,
          connectionCount: data.connectionCount,
        })),
        share(),
      );

    const getLivesFromApiInterval = interval(INTERVAL).pipe(
      exhaustMap(() => getLivesFromApi),
      retry(),
      catchError(async (err) => {
        console.error(err);
        throw err;
      }),
      share(),
    );

    this.lives$ = merge(getLivesFromApi, getLivesFromApiInterval);

    this.subscription.add(this.lives$.subscribe());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
